lazyAjax()

function lazyAjax() {
  /*
         #### ##    ##
          ##  ####  ##
 #######  ##  ## ## ##
          ##  ##  ####
         #### ##    ##

Intersection Observerで発火させる
連鎖的に読み込む場合はApplyのコールバックでもintObsAjax()を実行する
<div class="js-intLazy" data-from="#a" data-to="#a" data-type="add" data-push="off" data-url="">&emsp;</div>
*/

  if (document.getElementsByClassName('js-intLazy')[0]) {
    intObsAjax()
  }
  function intObsAjax() {
    const intObsOption = {
      // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
      rootMargin: '0px 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(intObsCallback, intObsOption)
    const intObsItems = document.getElementsByClassName('js-intLazy')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function intObsCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        if (entry.isIntersecting) {
          const item = entry.target

          const url = item.dataset.url // 取得先
          const type = item.dataset.type // add(追加)もしくはrep(差し替え)
          const from = item.dataset.from // 取得要素
          const to = item.dataset.to // 差し替え要素
          const pushSt = item.dataset.push // URLのプッシュ
          const scroll = item.dataset.scroll // スクロール先
          const flag = item.dataset.flag // 追加の処理フラグ
          applyAjax(url, 'get', null, from, to, pushSt, type, scroll, flag)
          observer.unobserve(item) // 監視対象から外す
          // item.parentNode.removeChild(item) // DOM削除
        }
      }
    }
  }

  /*
           ###    ########  ########  ##       ##    ##
         ##   ##  ##     ## ##     ## ##         ####
####### ##     ## ########  ########  ##          ##
        ######### ##        ##        ##          ##
        ##     ## ##        ##        ########    ##
*/
  /**
   * Ajax処理を実行する
   * @param url {string} 取得先のURL
   * @param from {string} 書き換え元のセレクタ　,区切りで複数指定
   * @param to {string} 取得先のセレクタ　,区切りで複数指定
   * @param pushSt {string|boolean} 擬似的にページ遷移する　falseじゃなければ有効
   * @param type {string} rep:要素を書き換える add:書き換え元の下に追加する
   * @param scroll {string} 指定の位置にスクロールさせる
   * @param flag {string} 独自の拡張用
   */
  function applyAjax(url, method = 'get', param, from, to, pushSt, type = 'rep', scroll = false, flag = null) {
    let ajax = false // Ajaxリクエスト
    let ajaxResponse = '' // 最後のレスポンスを格納する

    const fromList = from.split(',') // ,区切りで配列に変換
    const toList = to.split(',') // ,区切りで配列に変換

    const loadingItem = document.createElement('div')
    loadingItem.className = 'md-loading active'

    // ローディング処理
    for (let index = 0; index < toList.length; index++) {
      const itemTo = document.querySelector(toList[index])
      const loadingItem = document.createElement('div')
      loadingItem.className = 'md-loading active'
      if (type === 'rep') {
        loadingItem.style.width = itemTo.offsetWidth + 'px'
        loadingItem.style.height = itemTo.offsetHeight + 'px'
        itemTo.innerHTML = ''
      }
      itemTo.appendChild(loadingItem)
    }

    ajax = new XMLHttpRequest() // Ajaxリクエスト
    if (method === 'post') {
      ajax.open(method, url, true) // GET/POST, URL, 非同期処理
    } else {
      if (param) {
        url += (~url.indexOf('?') ? '&' : '?') + param // パラメータをURLに結合
      }
      if (pushSt === 'on') {
        history.pushState(null, null, url) // URL変更
      }
      // Ajaxと明示するパラメータを付ける
      url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
      ajax.open(method, url, true) // GET/POST, URL, 非同期処理
    }
    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
    ajax.setRequestHeader('Pragma', 'no-cache')
    ajax.setRequestHeader('Cache-Control', 'no-cache')
    ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
    if (method === 'post') {
      ajax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded') // POST時に必要なリクエストヘッダー
    }
    ajax.responseType = 'document' // 取得タイプ document text json
    ajax.timeout = 60000 // タイムアウト判定時間
    if (method === 'post') {
      ajax.send(param) // POSTリクエスト実行
    } else {
      ajax.send() // GETリクエスト実行
    }
    ajax.onload = function () {
      // アクセス成功
      if (ajax.status < 200 || ajax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー
        return
      }

      if (ajax.response === ajaxResponse) {
        // 前と結果が同じなら何もしない
        return
      }
      ajaxResponse = ajax.response // 取得結果を更新

      let ajaxData = ajaxResponse // 実際に使用するデータ

      for (let index = 0; index < toList.length; index++) {
        const itemFrom = ajaxData.querySelector(fromList[index])
        const itemTo = document.querySelector(toList[index])

        const delLoading = itemTo.querySelector('.md-loading')
        delLoading.parentNode.removeChild(delLoading)
        itemTo.innerHTML += itemFrom.innerHTML
        itemTo.style = ''
      }
    }
    ajax.ontimeout = function (e) {
      // タイムアウト
    }
    ajax.onerror = function () {
      // Ajax処理失敗
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
      // intObsAjax()
      window.slider()
      window.hoverSync()
      window.textExpand()
      ajax = false
    }
  }
}
